/**
 * Copy-link button: copies a URL to the clipboard and confirms with a short-lived bubble,
 * leaving the button's own label alone.
 *
 * Matches legacy stampa-su-tela.it, measured on /NSLC36QG/ 2026-08-20, whose handler is
 *   showbubble() { $('.copy-bubble').slideDown(); setTimeout(slideUp, 3000) }
 * on a div reading "Copiato negli appunti". The label there never changes. The theme used to
 * swap the label to a `copied_label` instead, and because that field is empty in the
 * metaobject the label was replaced with itself — clicking looked like it did nothing.
 *
 * The slide is not reproduced: it is jQuery easing, and this theme has no jQuery. Appearing
 * for three seconds and going away is the behaviour; the easing is not worth a dependency.
 *
 * Zero dependencies, progressive: with no JS, or with the clipboard API unavailable or
 * blocked, the button stays inert and silent rather than claiming a copy that never happened.
 */
const BUBBLE_VISIBLE_MS = 3000;

class CopyLinkButton extends HTMLElement {
  #bound = false;

  connectedCallback() {
    // connectedCallback fires again if the element is detached and re-attached — moving a
    // block in the Theme Editor does exactly that. Without this guard the click handler is
    // added twice, and the two closures then own separate timers: one can hide the bubble
    // while the other has just shown it.
    if (this.#bound) return;
    const btn = this.querySelector('button');
    const bubble = this.querySelector('[data-copy-bubble]');
    const url = this.dataset.url;
    if (!btn || !url || !navigator.clipboard) return;

    this.#bound = true;
    let hideTimer = null;

    btn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
      } catch {
        // Clipboard blocked (permission, insecure context, older browser). Say nothing.
        return;
      }
      if (!bubble) return;
      bubble.classList.remove('hidden');
      // Re-clicking restarts the three seconds instead of letting the first timer close the
      // bubble while the second click is still fresh.
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        bubble.classList.add('hidden');
      }, BUBBLE_VISIBLE_MS);
    });
  }
}

if (!customElements.get('copy-link-button')) {
  customElements.define('copy-link-button', CopyLinkButton);
}
